{
  "main": {
    "title": "Repertorio aeromobili",
    "nazaj": "Indietro"
  },
  "navs": {
    "vnos": "Inserimento",
    "seznam": "Elenco",
    "modal": {
      "pregled": "Dati",
      "servisna": "Libretto di manutenzione"
    }
  },
  "table": {
    "registracija": "Registrazione",
    "tip": "Tipo",
    "vrsta": "Categoria",
    "podrobno": "dettagli",
    "s_ure": "Totale ore",
    "s_letov": "Totale voli"
  },
  "modal": {
    "vlecno": "Aereo da traino:",
    "obracun_servis": "Registrazione del tempo di volo:",
    "razpolozljivo": "Visibile nella disponibilità:",
    "camo_pregled": "Visibile nella Camo:",
    "camo_flight": "Visualizzazione del tempo di volo in CAMO:",
    "tip": "Tipo:",
    "model": "Modello:",
    "serijska": "Serial:",
    "masa_plovila": "Teža plovila:",
    "klub": "Club:",
    "stUr": "Numero di ore:",
    "stLetov": "Numero di voli iniziali:",
    "stSUr": "Stato degli orologi:",
    "vrsta": "Categoria dell'aeromobile:",
    "datumN": "Data d’acquisto:",
    "datumR": "Data di registrazione:",
    "opombaJ": "Nota aliante:",
    "opomba": "Nota:",
    "datumV": "Data di inserimento:",
    "servis": {
      "stSUr": "Stato degli orologi:",
      "stLetov": "Stato dei voli:",
      "interval": "Intervallo di manutenzione: ",
      "datum_zServis": "Data dell'ultimo intervento di manutenzione: ",
      "opravljen_servis": "Servis opravljen pri:",
      "naslednji_servis": "Prossimo servizio: ",
      "status": "Status: ",
      "doServisa": "Numero di ore rimanenti fino alla manutenzione: ",
      "plovnost": "L'aereo è in condizioni di volo?",
      "plovnost_opomba": "Nota sul motivo per cui l'aereo non è galleggiante::"
    },
    "wb": {
      "minCG": "C.G. min. ({enota}):",
      "maxCG": "C.G. max. ({enota}):",
      "mTeza": "MTOW ({enota}):",
      "mGorivo": "Carburante ({enota}):",
      "pTeza": "Peso a vuoto ({enota}):",
      "tPilot": "Pilota & Passeggero - anteriore ({enota}):",
      "tPotniki": "Passeggero(i) - posteriore ({enota}):",
      "tPrtljaga": "Bagaglio ({enota}):",
      "maxGorivo": "Quantità max. di carburante ({enota}):",
      "maxPrtljaga": "Peso max. del bagaglio ({enota}):",
      "imaZadnji": "L'aereo ha i passeggeri nella parte posteriore (4 posti a sedere e oltre)?",
      "wgt": "Wgt {stevilka}:"
    }
  },
  "labels": {
    "vlecno": "Aereo da traino:",
    "tip": "Tipo:",
    "model": "Modelo:",
    "serijska": "Serial:",
    "masa_plovila_edit": "Peso dell'imbarcazione ({enota}):",
    "klub": "Seleziona club:",
    "stUr": "Numero di ore:",
    "stLetov": "Numero di voli:",
    "vrsta": "Seleziona categoria:",
    "datumN": "Data d’acquisto:",
    "datumR": "Data di registrazione:",
    "opombaJ": "Nota aliante:",
    "komponenta": {
      "ime": "Ime komponente",
      "servis_interval": "Intervallo di manutenzione: ",
      "zadnji_servis": "Manutenzione effettuata presso:",
      "naslednji_servis": "Prossimo servizio: ",
      "servis_opravljen": "Data dell'ultimo intervento di manutenzione:"
    },
    "obracunStevec": "Registrazione del tempo di volo:",
    "razpolozljivo": "Visibile nella disponibilità:",
    "camo_pregled": "Mostra nella CAMO:"
  },
  "buttons": {
    "uredi": "Modifica dati",
    "posodobi": "Aggiorna dati",
    "brisi": "Elimina aeromobile",
    "brisiIzbiro": "Cancella selezione",
    "csv": "Export CSV",
    "servis": {
      "uredi": "Uredi servisne podatke",
      "posodobi": "Posodobi servisne podatke"
    },
    "dodajKomponento": "Aggiungi un componente"
  }
}